module.exports = __webpack_public_path__ + "img/cz.9c5898c6.svg";